import { Flex, Text, IconButton, Icon, Divider, HStack, useMediaQuery, theme, Button, Stack, ListItem, UnorderedList } from '@chakra-ui/react';
import React from 'react';
import { GrFacebookOption } from 'react-icons/gr';
import { AiFillInstagram } from 'react-icons/ai';
import { FaTiktok, FaTwitter } from 'react-icons/fa';
import LocalizationSelector from 'Components/LocalizationSelector';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'Routes/AppRoutes';

interface IFooterProps{
	isBusiness?: boolean
}

export const Footer = ({isBusiness}:IFooterProps) => {
	const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
	const navigate = useNavigate();

	return (
		<Stack bg="#264653" 
			py={'60px'}
			px={{base: '30px', xl: '80px', '2xl': '192px' }}
		>
			<Flex
				justifyContent={'space-between'}
				
				direction={['column', 'row']}
			>
				
				<Stack
					justifyContent={{ base: 'center', lg: 'center' }}
					spacing={['20px', '30px']}
					mb={['20px', 0]}
				>
					<Text color={'white'} textTransform={'uppercase'} fontFamily={'Futura'}  fontSize={['16px', '16px', '16px','18px']} fontWeight={600}>Location Preference</Text>
					<LocalizationSelector footer fontSize={isMobile ? '12px' : '16px'} direction='column' />
				</Stack>
				<Stack justify={'start'} align={'flex-start'} mb={['20px', 0]} spacing={['20px', '30px']} >
					<Text color={'white'} textTransform={'uppercase'} fontFamily={'Futura'} fontSize={['16px', '16px', '16px','18px']} fontWeight={600}>Loop</Text>
					<Button cursor={'pointer'} 
						onClick={() => {
							navigate( AppRoutes.EnterCode);
						}}
						fontSize={['12px', '16px']}
						fontWeight={'normal'}
						color={'white'}
						_hover={{ textDecoration : 'underline' }}
					>
						Enter Code
					</Button>
					<Button cursor={'pointer'} onClick={() => {navigate('');}}
						fontSize={['12px', '16px']}
						fontWeight={'normal'}
						color={'white'} 
						_hover={{ textDecoration : 'underline' }}
					>
						FAQ
					</Button>
				</Stack>
				<Stack justify={'start'} align={'flex-start'} mb={['20px', 0]} spacing={['20px', '30px']} >
					<Text textTransform={'uppercase'} fontFamily={'Futura'}  color={'white'}  fontSize={['16px', '16px', '16px','18px']} fontWeight={600}>Business</Text>
					<Button cursor={'pointer'} 
						onClick={() => {
							navigate( AppRoutes.LoopForBusiness);
						}}
						fontSize={['12px', '16px']}
						fontWeight={'normal'}
						color={'white'} 
						_hover={{ textDecoration : 'underline' }}
					>
						Loop for business
					</Button>
					<Button cursor={'pointer'} 
						onClick={() => {
							navigate( AppRoutes.processOverview);
						}}
						fontSize={['12px', '16px']}
						fontWeight={'normal'}
						color={'white'} 
						_hover={{ textDecoration : 'underline' }}
					>
						How it works
					</Button>
					<Button cursor={'pointer'} 
						onClick={() => {
							navigate( AppRoutes.Echo);
						}}
						fontSize={['12px', '16px']}
						fontWeight={'normal'}
						color={'white'} 
						_hover={{ textDecoration : 'underline' }}
					>
						Echo AI
					</Button>
				</Stack>
				<Stack justify={'start'} align={'flex-start'} mb={['20px', 0]} spacing={['20px', '30px']} >
					<Text textTransform={'uppercase'} fontFamily={'Futura'}  color={'white'}  fontSize={['16px', '16px', '16px','18px']} fontWeight={600}>Contact Us</Text>
					<Button cursor={'pointer'} 
						onClick={() => {
							navigate( AppRoutes.contact);
						}}
						fontSize={['12px', '16px']}
						fontWeight={'normal'}
						color={'white'} 
						_hover={{ textDecoration : 'underline' }}
					>
						Contact
					</Button>
				</Stack>
				<Stack  justify={'start'} align={'flex-start'} mb={['20px', 0]} spacing={['20px', '30px']}>
					<Text textTransform={'uppercase'} fontFamily={'Futura'}  color={'white'}  fontSize={['16px', '16px', '16px','18px']} fontWeight={600}>Follow Us</Text>
					<HStack spacing={'30px'} >
						<IconButton color={'white'}  aria-label='facebook share' icon={<Icon as={GrFacebookOption} h={['14px', '20px']} w={['14px', '20px']} />} />
						<IconButton color={'white'}  aria-label='insta share' icon={<Icon as={AiFillInstagram} h={['14px', '20px']} w={['14px', '20px']} />} />
						<IconButton color={'white'}  aria-label='tiktok share' icon={<Icon as={FaTiktok} h={['14px', '20px']} w={['14px', '20px']} />} />
						<IconButton color={'white'}  aria-label='twitter share' icon={<Icon as={FaTwitter} h={['14px', '20px']} w={['14px', '20px']} />} />
					</HStack>
				</Stack>
				
			</Flex>
			<Divider
				borderColor={'white'}
				variant={'solid'}
				size={'2px'}
				pt={'30px'}
			/>
			<Flex gap={[3, 0]} direction={['column', 'row']} pt={['20px','30px']} color={'white'} justifyContent={'space-between'} alignItems={['start','center']}>
				<UnorderedList w={'400px'} display={'flex'} gap={[2,0]} flexDirection={['column', 'row']}  justifyContent={'space-between'} alignItems={['start','center']}>
					<ListItem>Feedtheloop.com</ListItem>
					<ListItem>Sitemap</ListItem>
					<ListItem cursor={'pointer'} 
						onClick={() => {
							navigate( isBusiness ? AppRoutes.termsOfServiceBrands : AppRoutes.termsOfServiceUser);
						}}
						fontWeight={'normal'}
						color={'white'} 
						_hover={{ textDecoration : 'underline' }}
					>
						Terms & Conditions
					</ListItem>
					<ListItem cursor={'pointer'} 
						onClick={() => {navigate(AppRoutes.privacyPolicy);}}
						fontWeight={'normal'}
						color={'white'} 
						_hover={{ textDecoration : 'underline' }}
					>
						Privacy
					</ListItem>
				</UnorderedList>
				<Text textAlign={'center'}>All rights reserved - Feed the Loop &copy; {new Date().getFullYear()}</Text>
			</Flex>
		</Stack>
	);
};